import { useEffect, useState } from "react";
import {
  Button, Modal, ModalBody, ModalCloseButton, ModalContent,
  ModalFooter, ModalHeader, ModalOverlay, FormControl, FormLabel, Input,
} from "@chakra-ui/react";

export default function EditFolderModal({
  OnSubmit = () => {},
  IsLoading = false,
  OnClose = () => {},
  IsOpen = false,
  FolderData,
  texts = {} 
}) {
  const fileManagerTexts = texts?.fileManager || {};
  const generalTexts = texts?.general || {};
  
  const [Name, SetName] = useState("");

  useEffect(() => {
    if (IsOpen && FolderData?.FolderName) {
      SetName(FolderData.FolderName);
    } else if (!IsOpen) {
      SetName("");
    }
  }, [IsOpen, FolderData]);

  const handleSubmit = async () => {
    if (!FolderData || !FolderData.FolderId) {
      console.error("FolderData or FolderId is missing!");
      return;
    }

    const success = await OnSubmit({
      FolderName: Name,
      FolderId: FolderData.FolderId,
      Tab: "Edit",
    });
    
    if (success) {
      OnClose();
    }
  };

  return (
    <Modal isOpen={IsOpen} onClose={OnClose} isCentered>
      <ModalOverlay />
      <ModalContent as="form" onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
        <ModalHeader>{fileManagerTexts.rename || "Rename Folder"}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl isRequired>
            <FormLabel>{fileManagerTexts.newFolderName || "New folder name"}</FormLabel>
            <Input
              value={Name}
              onChange={(e) => SetName(e.target.value)}
              autoFocus
              onFocus={(e) => e.target.select()}
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button 
            type="submit" 
            colorScheme="blue" 
            mr={3} 
            isLoading={IsLoading} 
            isDisabled={!Name}
          >
            {generalTexts.saveChanges || "Save Changes"}
          </Button>
          <Button variant="ghost" onClick={OnClose}>
            {generalTexts.cancel || "Cancel"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}